export { default } from './Icon';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/Icon/index.js
// module id = 332
// module chunks = 0